import {
  Sun,
  Cloud,
  CloudSun,
  CloudRain,
  CloudSnow,
  CloudLightning,
  CloudDrizzle,
  CloudFog,
} from "lucide-react";

// Open-Meteo WMO weather codes
export function weatherInfo(code, isDay = 1) {
  const map = {
    0: { label: "Clear", Icon: isDay ? Sun : Cloud },
    1: { label: "Mainly clear", Icon: isDay ? Sun : Cloud },
    2: { label: "Partly cloudy", Icon: CloudSun },
    3: { label: "Overcast", Icon: Cloud },
    45: { label: "Fog", Icon: CloudFog },
    48: { label: "Rime fog", Icon: CloudFog },
    51: { label: "Light drizzle", Icon: CloudDrizzle },
    53: { label: "Drizzle", Icon: CloudDrizzle },
    55: { label: "Heavy drizzle", Icon: CloudDrizzle },
    61: { label: "Light rain", Icon: CloudRain },
    63: { label: "Rain", Icon: CloudRain },
    65: { label: "Heavy rain", Icon: CloudRain },
    71: { label: "Light snow", Icon: CloudSnow },
    73: { label: "Snow", Icon: CloudSnow },
    75: { label: "Heavy snow", Icon: CloudSnow },
    80: { label: "Showers", Icon: CloudRain },
    81: { label: "Heavy showers", Icon: CloudRain },
    82: { label: "Violent showers", Icon: CloudRain },
    95: { label: "Thunderstorm", Icon: CloudLightning },
    96: { label: "Storm w/ hail", Icon: CloudLightning },
    99: { label: "Severe storm", Icon: CloudLightning },
  };
  return map[code] || { label: "—", Icon: Cloud };
}
